import {
  Definition,
  DefinitionList,
  SkeletonParent,
} from "@apex/component-library";

export interface SkeletonDefinitionListProps {
  count: number;
}

const SkeletonDefinitionList = ({ count }: SkeletonDefinitionListProps) => {
  return (
    <DefinitionList>
      <SkeletonParent isLoading>
        {[...Array(count)].map((_, i) => {
          return (
            <Definition
              key={i}
              definition="Loading"
              term="Loading"
              m="1"
              height="30px"
            />
          );
        })}
      </SkeletonParent>
    </DefinitionList>
  );
};

export default SkeletonDefinitionList;
